import React from "react"
import "../../pages/mystyles.scss"
import '../../pages/index.css'

export default ({ children }) => (
  <div className="app">
    {children}
  </div>
)